"use strict"

import {observable, action} from "mobx"

import {getFilters} from "../../global/helpers/api"
import api from "../../global/actions/api"

import GlobalStore from "../../global/store/GlobalStore"

class AllocationsStore {
	@observable data = []

	@action getAllocations() {
		GlobalStore.loading(true, "Načítam...")

		let req = getFilters([])

		api
			.getAllocations(req)
			.call()
			.then((res) => {
				if (isSafe(res) && isSafe(res.rows)) {
					this.data = res.rows
				} else {
					this.data = []
				}

				GlobalStore.loading(false)
			})
	}
}

var singleton = new AllocationsStore()
export default singleton

